import Constants from "expo-constants";

/**
 * Whether this build is running as the production app (EAS profile
 * `APP_ENV=production`, or a web build/deploy where `APP_ENV` isn't set and
 * defaults to `"production"` — see `app.config.ts`).
 *
 * Used to gate internal-only routes (e.g. `/development/*`) that must never
 * be reachable by end users, even via a direct URL.
 */
export function isProductionEnvironment(): boolean {
  const environment = Constants.expoConfig?.extra?.environment as string | undefined;
  return environment === "production";
}
